import _ from "underscore";
import $ from "jquery";
import Backbone from "backbone";

export default Backbone.View.extend({

        // initialize
        initialize: function () {
            var $cards = this.$(".js-PubliFlipCard-item"),
                $triggers = this.$(".js-PubliFlipCard-trigger"),
                itemPrefix = this.$el.data("flipcard-item-prefix") || "PubliFlipCard-item",
                triggerPrefix = this.$el.data("flipcard-trigger-prefix") || "PubliFlipCard-trigger";
            
            this.$cards = $cards;
            this.$triggers = $triggers;
            this.itemFlipClass = itemPrefix + "--flip";
            this.triggerFlipClass = triggerPrefix + "--flip";
            this.initRender(true); // ok first time
            
        },

        // events
        events: {
            "click .js-PubliFlipCard-trigger": "flipFace"
        },

        

        // flipFace
        flipFace: function (e) {
            e.preventDefault();
            var $this = $(e.target),
                index = this.$triggers.index($this);
            //this.initRender();
            this.render(index);
        },


        // initRender
        // @param bool to detect if it is the first time
        initRender: function (isFirstTime) {
          this.$triggers.each((index, trigger) => {
            var $trigger = $(trigger);
            if (isFirstTime) {
              $trigger.data("flipCard_itemState", "OFF");
            }
            $trigger.removeClass(this.triggerFlipClass);
          });
        },


        // render
        render: function (n) {
            var $card = this.$cards.eq(n),
                $trigger = this.$triggers.eq(n),
                thisIsClosed = ($trigger.data("flipCard_itemState") === "OFF" ? true : false);

            if (thisIsClosed) {
                $card.addClass(this.itemFlipClass);
                $trigger
                    .data("flipCard_itemState", "ON")
                    .addClass(this.triggerFlipClass);

            } else {
                $card.removeClass(this.itemFlipClass);
                $trigger
                    .data("flipCard_itemState", "OFF")
                    .removeClass(this.triggerFlipClass);
            }
            
        }

    });
